import MobileDetect from "mobile-detect";

/**
 * Determines if the user is on a mobile device.
 * @returns {boolean} True if the device is mobile, otherwise false.
 */
const isMobile = (): boolean => {
  const md = new MobileDetect(window.navigator.userAgent);
  return Boolean(md.mobile());
};

export default isMobile;
